'use strict';

var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('LibertyAvV2');

function LibertyAvV2(ipAddress, username, password, onConnectStatus, onControlStatus, config) {
    this.busy = false;
    this.videoMatrixRoutes = {};

    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

LibertyAvV2.prototype = Object.create(CmdDevice.prototype);

LibertyAvV2.prototype.constructor = LibertyAvV2;

LibertyAvV2.prototype.name = 'LibertyAvV2';
LibertyAvV2.prototype.key = '-LWTYP1FZWGgOLHyYURN';
LibertyAvV2.prototype.isAsync = false;
LibertyAvV2.prototype.rejectAsync = false;
LibertyAvV2.prototype.syncTimeoutMs = 2000;
LibertyAvV2.prototype.sendTerminator = '\r';

LibertyAvV2.prototype.ports = [{
    port: 23,
    verifySend: null,
    verifyConnection: /welcome to/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
    loginVerifyTimeoutMs: 0
}];

LibertyAvV2.prototype.simulationParams = {
    caps: {
        hasVideoInputs: true,
        hasVideoOutputs: true,
        hasVideoSwitcher: true,
    }
};

LibertyAvV2.prototype.commands = {};

LibertyAvV2.prototype.commands.$getRouteInit = {};
LibertyAvV2.prototype.commands.$getRouteInit.activeStates = [ 'initializing' ];
LibertyAvV2.prototype.commands.$getRouteInit.activeInitializeStates = [ 'gettingRoutes' ];
LibertyAvV2.prototype.commands.$getRouteInit.get = function() {
    var outIds = Object.keys(this.config.videoOutputs).sort();
    var outCode =
        this.config.videoOutputs[outIds[this.initializeRepeatIndex]].code;

    this.sendCommand('$getRouteInit', 'GET ' + outCode);
};
LibertyAvV2.prototype.commands.$getRouteInit.match = /(\d+)>(\d+)/i;
LibertyAvV2.prototype.commands.$getRouteInit.process = function(match) {
    this.updateVideoMatrixRoute(match[1], match[2]);
    this.doNextInitializeStep();
};

LibertyAvV2.prototype.commands.busy = {};
LibertyAvV2.prototype.commands.busy.get = function() {
    this.broadcastStatus('busy', this.busy);
};

LibertyAvV2.prototype.commands.ping = {};
LibertyAvV2.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
LibertyAvV2.prototype.commands.ping.get = function() {
    this.sendCommand('ping', 'GET STANDBY');
};
LibertyAvV2.prototype.commands.ping.match = /WAKE!|STANDBY!/i;
LibertyAvV2.prototype.commands.ping.process = function(match) {
};

LibertyAvV2.prototype.commands.videoMatrixRoute = {};
LibertyAvV2.prototype.commands.videoMatrixRoute.isAsync = true;
LibertyAvV2.prototype.commands.videoMatrixRoute.get = function() {
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
};
LibertyAvV2.prototype.commands.videoMatrixRoute.set = function(value) {
    if (!this.videoMatrixRoutes.hasOwnProperty(value.videoOutputId)) {
        log.error(this + ' invalid videoOutputId = ' + value.videoOutputId);
        return;
    }

    if (!this.config.videoInputs.hasOwnProperty(value.videoInputId)) {
        log.error(this + ' invalid videoInputId = ' + value.videoInputId);
        return;
    }

    this.videoMatrixRoutes[value.videoOutputId] = value.videoInputId;
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);

    this.sendCommand('videoMatrixRoute', 'SET ' +
        this.config.videoInputs[value.videoInputId].code + ' ' +
        this.config.videoOutputs[value.videoOutputId].code);
};
LibertyAvV2.prototype.commands.videoMatrixRoute.match = /(\d+)>(\d+)/i;
LibertyAvV2.prototype.commands.videoMatrixRoute.process = function(match) {
    this.updateVideoMatrixRoute(match[1], match[2]);
};

LibertyAvV2.prototype.initializeSteps = [{
    state: 'gettingRoutes',
    action: '$getRouteInit',
    getRepeatCount: function() {
        return this.config.hasOwnProperty('videoOutputs') ?
            Object.keys(this.config.videoOutputs).length : 0;
    },
}, {
    state: 'finishingInitialization',
    action: function() {
        this.finishInitialization();
        return true;
    },
}];

LibertyAvV2.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    caps.hasVideoSwitcher = true;
    this.computeCapsFromConfig(caps);
    caps.hasBusy = true;

    return caps;
};

LibertyAvV2.prototype.onInitialize = function() {
    this.videoMatrixRoutes = {};
    this.startInitializer();
};

LibertyAvV2.prototype.updateVideoMatrixRoute = function(inputCode, outputCode) {
    var inputId = null;
    var outputId = null;

    for (var inId in this.config.videoInputs) {
        if (!this.config.videoInputs.hasOwnProperty(inId)) continue;
        if (this.config.videoInputs[inId].code === inputCode) {
            inputId = inId;
            break;
        }
    }

    if (inputId === null) {
        log.warning(this + ': unmatched video input code: ' + inputCode);
    }

    for (var outId in this.config.videoOutputs) {
        if (!this.config.videoOutputs.hasOwnProperty(outId)) continue;
        if (this.config.videoOutputs[outId].code === outputCode) {
            outputId = outId;
            break;
        }
    }

    if (outputId === null) {
        log.warning(this + ': unmatched video output code: ' + outputCode);
    }

    if (this.videoMatrixRoutes[outputId] !== inputId) {
        this.videoMatrixRoutes[outputId] = inputId;
        if (this.fsm.current === 'controlling') {
            this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
        }
    }
};

module.exports = LibertyAvV2;
